import { render, staticRenderFns } from "./ChallengerAdvisers.vue?vue&type=template&id=094f858e&scoped=true"
import script from "./ChallengerAdvisers.vue?vue&type=script&lang=ts"
export * from "./ChallengerAdvisers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094f858e",
  null
  
)

export default component.exports